export const ADMIN = "ADMIN";
export const REQUERIMIENTO = "REQ";
export const CONTROL_REQ = "CONTROL_REQ";
export const MODIFICAR_REQ = "MODIFICAR_REQ";